import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { format as dateFormat, parseISO } from 'date-fns';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { useGlobalComponent } from '@rhino-project/core/hooks';
export const CellDateBase = ({
  format,
  empty = '-',
  ...props
}: TableInheritedProps & { format?: string; empty?: string }) => {
  const { locale } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    if (!getValue!()) return empty;

    const date = parseISO(getValue!());
    return format
      ? dateFormat(date, format)
      : new Intl.DateTimeFormat(locale.replaceAll('_', '-'), {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(date);
  }, [empty, format, getValue, locale]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellDate = (props: TableInheritedProps) =>
  useGlobalComponent('CellDate', CellDateBase, props);
